import { CommonModule } from "@angular/common";
import { NgModule, Optional, SkipSelf } from "@angular/core";
import { RouterModule } from "@angular/router";
import { AuthModule } from "@app/auth/auth.module";
import { AppContainerComponent } from "@app/core/components/app-container/app-container.component";
// containers
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { AuditLogModule } from "@app/audit-log/audit-log.module";
import { AppComponent } from "@app/core/components/app/app.component";
import { SidenavComponent } from "@app/core/components/sidenav/sidenav.component";
import { SharedModule } from "@app/shared/shared.module";
import { MenuOverlayComponent } from "./components/menu-overlay/menu-overlay.component";
import { MobileReloadComponent } from "./components/mobile-reload/mobile-reload.component";
import { NewLandingPageComponent } from "./components/new-landing-page/new-landing-page.component";
import { NotFoundComponent } from "./components/not-found/not-found.component";
import { PermissionDeniedComponent } from "./components/permission-denied/permission-denied.component";
import { SidenavNewComponent } from "./components/sidenav-new/sidenav-new.component";

@NgModule({
    imports: [CommonModule, RouterModule, AuthModule, SharedModule, FormsModule, ReactiveFormsModule, AuditLogModule],
    declarations: [
        AppComponent,
        SidenavComponent,
        AppContainerComponent,
        NotFoundComponent,
        PermissionDeniedComponent,
        MobileReloadComponent,
        SidenavNewComponent,
        MenuOverlayComponent,
        NewLandingPageComponent,
    ],
})
export class CoreModule {
    /* make sure CoreModule is imported only by one NgModule the AppModule */
    constructor(@Optional() @SkipSelf() parentModule: CoreModule) {
        if (parentModule) {
            throw new Error("CoreModule is already loaded. Import only in AppModule");
        }
    }
}
